import { TaiLieuTaiSan, TaiSan } from "./TaiSan";

export interface ThanhLyTaiSan {
    id?: number;
    ngayLap: Date;
    noiDung?: string;
    trangThai: number;
    soLuongTaiSan?: number;
    soLuongTaiLieu?: number;
    nguoiTao?: string;
}

export interface ChiTietThanhLyTaiSan extends ThanhLyTaiSan {
    danhSachTaiSan: TaiSan[];
    dsTaiLieu: TaiLieuTaiSan[];
}

export interface ThanhLyTaiSanRequest {
    id?: number;
    ngayLap: string;
    noiDung?: string;
    idsTaiSan: number[];
    idsTaiLieuThanhLyXoa?: number[];
    files: any[];
}

export interface TimKiemThanhLyTaiSanRequest {
    tuKhoa?: string;
    trangThai?: number;
    tuNgay?: Date;
    denNgay?: Date;
}

export enum TrangThaiThanhLyTaiSan {
    DuThao = 0,
    HoanThanh = 1,
}
